var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass},[_c('span',{staticClass:"fal fa-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }